export function createDeferred() {
  let _resolve
  let _reject
  let _promise
  let resolved = false
  let result

  async function promise() {
    if (resolved) {
      return result
    }

    // ensuring at most 1 promise runs at anytime.
    if (_promise) {
      return _promise
    }

    _promise = new Promise((res, rej) => {
      _resolve = res
      _reject = rej
    })
  }

  function resolve(val) {
    _resolve(val)
    result = val
    resolved = true
    _promise = null
  }

  function reject(error) {
    _reject(error)
    result = undefined
    resolved = false
    _promise = null
  }

  return { promise, resolve, reject }
}

/**
 * Coalescing requests to avoid redundant fetching/payload handling.
 *
 * Case 1: Success - requests during flight share promise, after resolution get cached result
 *   R1─[═════════════════════════════════]✓─────────────────
 *       R2─────────>                          ├──R4 (cached)
 *          R3────────────>                    └──R5 (cached)
 *        in-flight (await same promise)     instant
 *
 * Case 2: Failure then retry - error clears state, next request starts fresh
 *   R1─[════════════════════════════]✗───R4─[════════════════════]✓───
 *       R2─────────>                          R5 ─────────>
 *          R3────────────>
 *     in-flight (all will fail)            triggers the promise again
 */
export function coalesce(asyncFunc) {
  let resolved = false
  let result
  let promise

  async function run() {
    if (resolved) {
      return result
    }

    if (promise) {
      return promise
    }

    try {
      promise = asyncFunc()
      result = await promise
      resolved = true
      return result
    } finally {
      promise = null
    }
  }

  return {
    run,
  }
}
